import script from "./CommonBeforeUnloadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonBeforeUnloadDialog.vue?vue&type=script&setup=true&lang=js"

import "./CommonBeforeUnloadDialog.vue?vue&type=style&index=0&id=e4166580&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4166580"]])

export default __exports__